import { Injectable } from '@angular/core';
import { ToastController } from 'ionic-angular';
import { device, thingShadow } from 'aws-iot-device-sdk';
import { User } from '../providers/providers';
import { ServerService } from '../service/server.service';

declare var AWS:any;
declare const aws_cognito_region;
declare const aws_cognito_identity_pool_id;
declare const aws_user_pools_id;
declare var iotClientId; 


@Injectable()
export class IotMessageService {

  results: string[];
  public instanceId = "i-001b0fa9adc70de63";
  IoTDevice:any;
  toast:any;
  CompletedCallBack:any;
  RefreshKMLCallBack:any;
  SpinnerCallBack:any;
  RefreshAlertCallBack:any;
  IotCreds:any;
  iotClientId = "Lrx-"+ (Math.floor((Math.random() * 100000) + 1));
  iotInitialized = false;

  constructor(private toastCtrl: ToastController, private service: ServerService) {
    
  }

  InitializeDevice(completeCallback,refreshKMLCallBack,instanceId:string, spinnerCallBack,refreshAlertCallBack, user:User = null){
      //NOTE NEED TO ADD USER FROM CLI SEE aws-IOT-policy-permission.txt
      this.iotClientId = "Lrx-"+ (Math.floor((Math.random() * 100000) + 1));
      this.instanceId = instanceId;
    this.CompletedCallBack = completeCallback;
    this.RefreshKMLCallBack = refreshKMLCallBack;
    this.SpinnerCallBack = spinnerCallBack;
    this.RefreshAlertCallBack = refreshAlertCallBack;
    if(!this.iotInitialized)
    {
        this.CompletedCallBack = completeCallback;
        AWS.config.region = 'us-west-2';
        
        if(user){
        var logins = {};
            var loginKey = 'cognito-idp.' +
                            aws_cognito_region +
                            '.amazonaws.com/' +
                            aws_user_pools_id;
            logins[loginKey] = user.getUser().signInUserSession.idToken.jwtToken;
        }
        //console.log(logins);
        /*this.IotCreds = new AWS.CognitoIdentityCredentials({
        IdentityPoolId: 'us-west-2:304a17bc-9983-41db-a632-878cab0de3b4',
        'Logins': logins
        });*/
        this.IotCreds = new AWS.CognitoIdentityCredentials({
            IdentityPoolId: aws_cognito_identity_pool_id,
            'Logins': logins
            });
            
        
        this.IotCreds.get((err) => {
            if(err){
                let errTest = err;
            }
        // Use these credentials with IoT
        let test = this.IotCreds;
        const accessKeyId =this.IotCreds.accessKeyId;
        const secretAccessKey = this.IotCreds.secretAccessKey;
        const sessionToken = this.IotCreds.sessionToken;
        const expiration = this.IotCreds.expireTime;
        

        
        //let iotClientId = "Lrx-"+ (Math.floor((Math.random() * 100000) + 1));
        this.IoTDevice = new device({
        protocol:"wss",
        //region: 'us-west-2',
        sessionToken: sessionToken,
        accessKeyId: accessKeyId,
        secretKey: secretAccessKey,
        clientId: this.iotClientId,
        host: "a35dny2d2819xa-ats.iot.us-west-2.amazonaws.com"
        //host: "a35dny2d2819xa.iot.us-west-2.amazonaws.com"
        });
    /*    this.IoTDevice = new device({
            protocol:"wss",
            region: 'us-west-2',
            sessionToken: '',
            accessKeyId: '',
            secretKey: '',
            clientId: iotClientId,
            host: "a35dny2d2819xa.iot.us-west-2.amazonaws.com"
        });
    */
        //this.IoTDevice.updateWebSocketCredentials(accessKeyId, secretAccessKey, sessionToken, expiration)
        this.IoTDevice.on('connect',this.onConnect);
        this.IoTDevice.on('message',this.onMessage);
        this.IoTDevice.on('error', this.onError);
        });
        this.iotInitialized = true;
    }
  }

    //Fat arrow used to keep scope, private entry back in
    public onError = (err) => {
        let test = "error";
        this.iotError(err);
    }

    iotError(err){
        //alert("Message error");
        let testerr = err;
        console.log(err);
    }

    //Fat arrow used to keep scope, private entry back in
    public onConnect = () => {
        let test = "connected";
        //this.IoTDevice.register('LRxApp',{
        //  persistentSubscribe: true
        //});
        //alert("connect");
        this.setSubscription();
    }
    
    setSubscription(){
        //PShield = i-0f60949bc7719b33d
        this.IoTDevice.subscribe("lrx/"+this.instanceId);
    }

    //Fat arrow used to keep scope, private entry back in
    public onMessage = (topic,payload) => {
        try {
            let message = JSON.parse(payload.toString());
            this.processMessage(message);
        } 
        catch (error) {
            console.log("error parsing iot message!")
        }

    }  

    processMessage(iotMessage){
        //dismiss current message
        if(this.toast){
            this.toast.dismiss();
        }
        if(iotMessage.dismiss > 0)
        {   
            this.toast = this.toastCtrl.create({
            message: iotMessage.message,
            duration: iotMessage.dismiss,
            position: 'top'
            });
        }
        else
        {
            this.toast = this.toastCtrl.create({
            message: iotMessage.message,
            position: 'top'
            });            
        }

        if(iotMessage.refreshMap === "true")
        {
            this.CompletedCallBack(iotMessage);
            this.SpinnerCallBack(false);


            //this.RefreshAlertCallBack(iotMessage);
        }

        if(iotMessage.refreshKML === "true"){
            this.RefreshKMLCallBack(iotMessage);
        }

        if(iotMessage.show_refresh_alert === "true")
        {
            this.RefreshAlertCallBack(iotMessage);
        }
        //else
        //{
        //    this.RefreshAlertCallBack(false);
        //}

        if(iotMessage.show_spinner === "true")
        {
            this.SpinnerCallBack(true);
        }
        else
        {
            this.SpinnerCallBack(false);
        }


      this.toast.onDidDismiss(() => {
          this.service.modelRunning = true;
        console.log('Dismissed toast');
      });    
      this.toast.present();
    }

}



// WEBPACK FOOTER //
// ./src/service/iot-message.service.ts